import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Loadable from 'react-loadable';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { withAuthGuard } from 'ggApp/modules/router/hocs';
import CompanyDashboard from 'ggApp/shared/screens/CompanyDashboard';

const Loading = (): JSX.Element => <CircleLoader className={undefined} />;

const Wrap = Loadable({
    loader: () => import('./wrap'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const GuardScreen = ({ children }: { children: React.ReactElement }): JSX.Element => (
    <React.Fragment>{children}</React.Fragment>
);

const CompanyDashboardeRoutes = (): JSX.Element => (
    <Route path="company-dashboard" component={withAuthGuard(GuardScreen)}>
        <Route component={Wrap}>
            <IndexRoute component={CompanyDashboard} />
        </Route>
    </Route>
);

export default CompanyDashboardeRoutes;
